import { Modal, Button } from "@mantine/core";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { SingleImageUploader } from "../UI/ImageHandler";

const FieldForm = ({ name, label, errors, touched, textarea = false }) => (
  <div>
    <label className='block mb-1 font-semibold'>{label}</label>

    {/* Field input or textarea */}
    <Field name={name}>
      {({ field }) => (
        <>
          {textarea ? (
            <>
              <textarea
                {...field}
                rows={4}
                maxLength={145}
                className='w-full border px-3 py-2 rounded-md dark:bg-black dark:text-white'
              />

              <div className='flex justify-between items-center'>
                <p className='text-xs text-left mt-1 text-gray-500'>
                  {
                    "use {{couponCode}} and {{couponValue}} to display coupon code and coupon amount"
                  }
                </p>
                <p className='text-xs text-right mt-1 text-gray-500'>
                  {field.value.length}/145 characters
                </p>
              </div>
            </>
          ) : (
            <input
              {...field}
              className='w-full border px-3 py-2 rounded-md dark:bg-black dark:text-white'
            />
          )}
        </>
      )}
    </Field>

    {/* Validation error */}
    {errors[name] && touched[name] && (
      <p className='text-red-500 text-sm mt-1'>{errors[name]}</p>
    )}
  </div>
);

const convertValueForUnit = (valueInMinutes, unit) => {
  switch (unit) {
    case "days":
      return Math.round(valueInMinutes / (60 * 24));
    case "hours":
      return Math.round(valueInMinutes / 60);
    case "minutes":
    default:
      return valueInMinutes;
  }
};

const SMSUpdatedModal = ({
  selectedSms,
  editModalOpen,
  setEditModalOpen,
  handleUpdateSubmit,
  updateLoading,
  couponOptions,
}) => {
  return (
    <div className='mt-4 bg-white  dark:bg-gray-800  rounded-2xl'>
      <Modal
        opened={editModalOpen}
        onClose={() => setEditModalOpen(false)}
        title='Update SMS Entry'
        centered
        overlayProps={{
          backgroundOpacity: 0.1,
          // blur: 3,
        }}
      >
        <div className=' max-h-96 overflow-y-auto  py-5'>
          {selectedSms && (
            <Formik
              initialValues={{
                key: selectedSms.key,
                mediaUrl: selectedSms.mediaUrl,
                value: convertValueForUnit(selectedSms.value, selectedSms.unit),
                unit: selectedSms.unit,
                message: selectedSms.message,
                couponId: selectedSms.couponId || "",
              }}
              validationSchema={Yup.object({
                key: Yup.string().required("Key is required"),
                value: Yup.string().required("Value is required"),
                message: Yup.string().required("Message is required"),
              })}
              onSubmit={handleUpdateSubmit}
            >
              {({ setFieldValue, values, errors, touched }) => (
                <Form className='flex flex-col space-y-4'>
                  <SingleImageUploader
                    title='Media Image'
                    values={values}
                    field={"mediaUrl"}
                    setFieldValue={setFieldValue}
                  />

                  <FieldForm
                    errors={errors}
                    touched={touched}
                    name='key'
                    label='Title'
                  />
                  <FieldForm
                    errors={errors}
                    touched={touched}
                    name='value'
                    label='Value'
                  />
                  <div>
                    <label className='block mb-1 font-semibold'>Unit</label>
                    <Field
                      name='unit'
                      as='select'
                      className='w-full border px-3 py-2 rounded-md dark:bg-black dark:text-white'
                    >
                      <option value='days'>Days</option>
                      <option value='hours'>Hours</option>
                      <option value='minutes'>Minutes</option>
                    </Field>
                  </div>
                  <div>
                    <label className='block mb-1 font-semibold'>
                      Coupon Code
                    </label>
                    <Field
                      as='select'
                      name='couponId'
                      className='w-full border px-3 py-2 rounded-md dark:bg-black dark:text-white'
                    >
                      <option value=''>-- Select Coupon --</option>
                      {couponOptions.map((c) => (
                        <option key={c._id} value={c._id}>
                          {`${c.title ? `${c.title} - ` : ""}${c.code} - ${
                            c.percentage ? `${c.percentage}%` : `${c.amount}$`
                          }`}
                        </option>
                      ))}
                    </Field>
                  </div>
                  <FieldForm
                    errors={errors}
                    touched={touched}
                    name='message'
                    label='Message'
                    textarea
                  />
                  <div className='flex gap-3'>
                    <Button type='submit' color='red' loading={updateLoading}>
                      Update
                    </Button>
                    <Button
                      variant='outline'
                      onClick={() => setEditModalOpen(false)}
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default SMSUpdatedModal;
